export default function getResource(label, vars = []) {
    const resources = {
        yearAtGlanceTitle: `${vars[0]} at a Glance`,
        yearAtGlanceError: 'We couldn\'t load your annual history right now.',
        yearAtGlanceSignedOut: `Sign in to access your ${vars[0]} at a Glance.`,
        yearAtGlanceNonBi: `Join to access your ${vars[0]} at a Glance.`,
        yearAtGlanceEmpty: `Your ${vars[0]} earnings will appear here. Keep shopping to get rewards, benefits, and discounts!`,
        rewardsRedeemedTitle: 'Rewards Redeemed',
        rewardsRedeemedError: 'We couldn\'t load your redeemed rewards right now.',
        rewardsRedeemedSignedOut: 'Sign in to access your redeemed rewards.',
        rewardsRedeemedNonBi: 'Join to start earning points and redeeming rewards.',
        rewardsRedeemedEmpty: 'Your redeemed rewards will appear here.',
        pointsHistoryTitle: 'Points History',
        pointsHistoryInfoLabel: 'Points History information',
        pointsHistoryError: 'We couldn\'t load your points history right now.',
        pointsHistorySignedOut: 'Sign in to access your points history.',
        pointsHistoryNonBi: 'Join to start earning points and track your points history.',
        pointsHistoryEmpty: 'Your points history will appear here.',
        pointsDisclaimer: 'Don\'t see your points yet? Your activity will update within 24 hours.',
        pointsInfoModalMessage: 'Points from eligible purchases and activity may take up to 24 hours to appear in your account.',
        modalOk: 'OK',
        viewDetails: 'View details',
        viewAll: 'View all',
        shopNow: 'Shop Now',
        retry: 'Retry',
        loadingPointsHistory: 'Loading points history',
        faqs: 'FAQs',
        terms: 'Beauty Insider Terms & Conditions',
        employeeDiscountPurchase: 'Employee Discount Purchase',
        promosAndDiscountApplied: 'Promos & Discount Applied',
        beautyInsiderCashApplied: 'Beauty Insider Cash Applied',
        creditCardRewardsEarned: 'Credit Card Rewards Earned',
        rougeRewardsEarned: 'Rouge Rewards Earned'
    };

    return resources[label];
}
